"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCurrencyId = void 0;
var blockchains_1 = require("./blockchains");
function toCurrencyId(value) {
    if (!(0, blockchains_1.isRealBlockchainSpecified)(value)) {
        throw new Error("Not an CurrencyId: " + value);
    }
    return value;
}
exports.toCurrencyId = toCurrencyId;
